<template>
  <Modal v-model="modal1" width="1000" :title="$t('key1001330')" footer-hide>
    <Input v-model.trim="keywords" @input="changeInput" clearable :placeholder="$t('key1001331')" style="margin: 10px;width: 300px;"></Input>
    <Table border :columns="columns1" max-height="400" :data="data2"></Table>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'authorizedStore',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      modal1: false,
      data2: [],
      keywords: '',
      columns1: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001324'),
          key: 'accountCode',
          align: 'center',
          tree: true
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001325'),
          align: 'center',
          key: 'accountName'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          align: 'center',
          key: 'status',
          render(h, params) {
            if (params.row.authAccountTokens) {
              let data = params.row.authAccountTokens;
              if (data) {
                return h('div', data.map(i => {
                  return h('p', [
                    h('span', i.authName),
                    h('span', {
                      style: {
                        color: i.status === 1 ? 'green' : 'red'
                      }
                    }, i.status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001326') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001327')),
                    i.authDescription ? h('Poptip', {
                      props: {
                        transfer: true,
                        'word-wrap': true,
                        trigger: 'hover',
                        content: i.authDescription
                      }
                    }, [
                      h('Icon', {
                        props: {
                          size: 16,
                          type: 'ios-help-circle'
                        }
                      })]) : ''
                  ]);
                }));
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          key: 'opts',
          width: 110,
          render(h, params) {
            let ymsPlatformAccountId = params.row.ymsPlatformAccountId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: ymsPlatformAccountId ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001328') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001329'),
                    show: true,
                    clickFn: () => {
                      v.addAuthStore('0', params.row.authAccountId, params.row.ymsPlatformAccountId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      data1: [],
    };
  },
  created() {

  },
  props: {},
  computed: {},
  methods: {
    changeInput() {
      this.data2 = this.data1.filter(i => {
        return i.accountCode.includes(this.keywords) || i.accountName.includes(this.keywords);
      });
    },
    addAuthStore(code, authAccountId, ymsPlatformAccountId) {
      let v = this;
      v.axios.get(api.get_ymsPlatformAccount_callback, {
        params: {
          code: code,
          authAccountId: authAccountId,
          ymsPlatformAccountId: ymsPlatformAccountId
        }
      }).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000839'));
          v.modal1 = false;
          v.$emit('getList');
        }
      });
    },
    getAuthorizedStore(params) {
      let v = this;
      v.axios.get(api.get_ymsPlatformAccount_queryAuthAccountList + '?platformId=' + params.platformId,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.modal1 = true;

          v.data1 = response.data.datas.map((i, index) => {
            i._parent = true;
            i.index = index + 'p';
            return i;
          });
          v.data2 = JSON.parse(JSON.stringify(v.data1));
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
